import moment from 'moment';
import { MutationTree } from 'vuex';
import { ArchiveState } from '../stores/archive.store';
import GroupFiltersEnum from '@/enums/GroupFilters';
import { IUser } from '@/types/User';
import { ITeam } from '@/types/Team';

export const mutationError = 'error';
export const mutationLoadingTeams = 'loadingTeams';
export const mutationSetTeams = 'setTeams';
export const mutationSetTeamsFilter = 'setTeamsFilter';
export const mutationSetEndDateFilter = 'setEndDateFilter';
export const mutationApplyEndDateFilter = 'applyEndDateFilter';
export const mutationSetTagFilter = 'setTagFilter';
export const mutationLoadingTags = 'loadingTags';
export const mutationSetGroupFilter = 'setGroupFilter';

export const mutations: MutationTree<ArchiveState> = {
  [mutationError](state: ArchiveState, error: string) {
    state.error = error;
  },
  [mutationLoadingTeams](state: ArchiveState, payload: boolean) {
    state.isLoadingTeams = payload;
  },
  [mutationSetTeams](state: ArchiveState, teams: ITeam[]) {
    state.teams = teams;
    state.error = '';
    state.isLoadingTeams = false;
  },
  [mutationSetTeamsFilter](state: ArchiveState, users: IUser[]) {
    state.teamsFilter = users;
  },
  [mutationSetEndDateFilter](
    state: ArchiveState,
    { from, to, month }: { from: Date; to: Date; month: Date }
  ) {
    state.endDateFilter = {
      ...state.endDateFilter,
      from,
      to,
      month,
    };
  },
  [mutationApplyEndDateFilter](state: ArchiveState) {
    const { month, from, to } = state.endDateFilter;
    let range = '';

    const dateFormat = 'YYYY-MM-DD';
    if (month) {
      range = `${moment(month).format(dateFormat)} - ${moment(month)
        .endOf('month')
        .format(dateFormat)}`;
    } else if (from || to) {
      range = `${from ? moment(from).format(dateFormat) : ''} - ${
        to ? moment(to).format(dateFormat) : ''
      }`;
    }
    state.endDateFilter = {
      ...state.endDateFilter,
      range,
    };
  },
  [mutationSetTagFilter](state: ArchiveState, payload: string) {
    state.tagFilter = payload;
  },
  [mutationLoadingTags](state: ArchiveState, payload: boolean) {
    state.isLoadingTags = payload;
  },
  [mutationSetGroupFilter](state: ArchiveState, payload: GroupFiltersEnum) {
    state.groupFilter = payload;
  },
};
